import type { Maybe } from '@adornis/base/utilTypes.js';
import { ID } from '@adornis/baseql/baseqlTypes.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import { context } from '@adornis/baseql/server/context.js';
import { ImageFile } from '@adornis/file-utils/db/images.js';
import { NotLoggedInError } from '@adornis/users/db/errors.js';

@Entity()
export class CompanyLogoFile extends ImageFile {
  static override _class = 'CompanyLogoFile';

  @Field(() => ID)
  ownerID: Maybe<string>;

  static override beforeCreate(entity: CompanyLogoFile): Promise<void> {
    if (!context.serverContext) {
      if (!context.userID) throw new NotLoggedInError();
      entity.ownerID = context.userID;
    }
    return super.beforeCreate(entity);
  }
}
